let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fFCZv")).then(() => parcelRequire('5SMTp'));